import React from 'react';
import { Image } from 'react-bootstrap';
// import logo from '../Images/joyride_logo.png';
import logo from '../Images/connect-artwork.svg';

let Logo = () => <Image style={{ borderRadius: 10, marginBottom: '1.5rem' }} src={logo} className="logo" />

export default Logo;